import React from 'react';
import * as types from './types';

export const setIsLoadingAction = () => ({
  type: types.SET_IS_LOADING,
  payload: {},
});

export const setIsNotLoadingAction = () => ({
  type: types.SET_IS_NOT_LOADING,
  payload: {},
});

export const showModalAction = ({
  title = '',
  content = '',
  link = null,
  options = {},
  Component = React.JSX,
}) => ({
  type: types.SHOW_MODAL,
  payload: { title, content, link, options, Component },
});

export const hideModalAction = () => ({
  type: types.HIDE_MODAL,
});

export const showAuthSuccess = value => ({
  type: types.SHOW_AUTH_SUCCESS,
  payload: { value },
});

export const setIsDashboardLoadedAction = () => ({
  type: types.SET_IS_DASHBOARD_LOADED,
  payload: {},
});

export const setAuthErrorAction = error => ({
  type: types.SET_AUTH_ERROR,
  payload: { error },
});
